<app-header [label]="'AI Admin'" [sub_label]="page_name"></app-header>

<div class="p-5 flex flex-col gap-4">

  <!-- Filters -->
  <div class="flex flex-wrap items-end gap-3">
    <div class="w-52">
      <app-select-input label="University" [is_disabled]="gs.access_scope.locked.university" [(ngModel)]="params.university_id" [options]="university_options" (ngModelChange)="on_university_change()">
      </app-select-input>
    </div>
    <div class="w-44">
      <app-select-input label="Role" [(ngModel)]="params.role_id" [options]="role_options" (ngModelChange)="apply_filters()">
      </app-select-input>
    </div>
    <div class="ml-auto flex items-center gap-2">
      <input type="text" [(ngModel)]="params.search" (ngModelChange)="apply_filters()" placeholder="Search by Name, Request ID" class="border border-gray-200 rounded-lg px-4 py-2 text-sm w-64 focus:outline-none focus:ring-2 focus:ring-[#3F41D1]/30" />
    </div>
  </div>

  <!-- Grid -->
  <app-ag-grid-list [list]="items" [colDefs]="columns" [show_checkboxes]="false" [itemName]="page_name" [rowHeight]="60" (fetch_new_list)="get_list($event)">
  </app-ag-grid-list>

</div>

<!-- ═══════════════════════════════════════════════════
     REVIEW MODAL
     ═══════════════════════════════════════════════════ -->
<div *ngIf="show_review_modal" class="fixed inset-0 z-40 flex items-center justify-center bg-black/50 px-4">
  <div class="bg-white rounded-2xl shadow-2xl w-full max-w-5xl flex flex-col max-h-[92vh] overflow-y-auto">

    <!-- Header -->
    <div class="flex items-start justify-between px-8 pt-7 pb-5 border-b border-gray-100">
      <div>
        <h2 class="text-[17px] font-extrabold text-[#111827] tracking-wide uppercase">Manual Verification Request</h2>
        <p class="text-[13px] text-[#6B7280] mt-1">Compare The Submitted Photo With The Aadhaar Record, Then Approve Or Reject.</p>
      </div>
      <button type="button" (click)="close_review()" class="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition flex-shrink-0 ml-4 mt-0.5">
        <svg class="w-5 h-5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Info row -->
    <div class="grid grid-cols-5 gap-4 px-8 py-5 border-b border-gray-100">
      <div>
        <p class="text-[12px] text-[#9CA3AF] mb-0.5">Name</p>
        <p class="text-[14px] font-bold text-[#111827]">{{ selected_request?.User?.name || '—' }}</p>
      </div>
      <div class="col-span-2">
        <p class="text-[12px] text-[#9CA3AF] mb-0.5">User ID</p>
        <p class="text-[14px] font-bold text-[#111827] break-all">{{ selected_request?.User?.email || '—' }}</p>
      </div>
      <div>
        <p class="text-[12px] text-[#9CA3AF] mb-0.5">Submitted</p>
        <p class="text-[14px] font-bold text-[#111827]">{{ format_submitted_date(selected_request?.created_at) }}</p>
      </div>
      <div>
        <p class="text-[12px] text-[#9CA3AF] mb-0.5">Request ID</p>
        <p class="text-[14px] font-bold text-[#111827]">{{ selected_request?.request_id || '—' }}</p>
      </div>
    </div>

    <!-- Captured photo -->
    <div class="px-8 pt-5 pb-4">
      <div class="rounded-xl overflow-hidden border border-gray-200 bg-white flex items-center justify-center m-auto w-fit px-40">
        <img *ngIf="captured_image_url" [src]="captured_image_url" alt="Captured Photo" class="w-auto object-cover max-h-[385px] object-top" />
        <div *ngIf="!captured_image_url" class="flex flex-col items-center gap-2 py-16">
          <svg class="w-14 h-14 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
          <p class="text-[13px] text-gray-400">No photo available</p>
        </div>
      </div>
    </div>

    <!-- Comment -->
    <div class="flex flex-col gap-2 px-8 pb-5">
      <p class="text-sm font-semibold">Comment <span class="text-xs font-normal">(Required When Rejecting)</span></p>
      <app-text-area label="" placeholder="Write Comment..." [(ngModel)]="review_comment"></app-text-area>
    </div>

    <!-- Footer -->
    <div class="flex justify-end gap-3 px-8 pb-7">
      <button *ngIf="gs.user_role_data?.ai_admin_login_request_reject" type="button" (click)="on_reject_click()" class="px-8 py-2.5 rounded-full bg-[#EF4444] text-white text-[14px] font-semibold hover:opacity-90 transition">
        Reject
      </button>
      <button *ngIf="gs.user_role_data?.ai_admin_login_request_approve" type="button" (click)="show_approve_modal = true" class="px-8 py-2.5 rounded-full bg-[#22C55E] text-white text-[14px] font-semibold hover:opacity-90 transition">
        Approve
      </button>
    </div>

  </div>
</div>

<!-- ═══════════════════════════════════════════════════
     APPROVE CONFIRMATION MODAL
     ═══════════════════════════════════════════════════ -->
<div *ngIf="show_approve_modal" class="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
  <div class="bg-white rounded-2xl shadow-2xl px-8 py-8 w-full max-w-sm mx-4 text-center">
    <div class="w-16 h-16 rounded-full bg-[#D1FAE5] flex items-center justify-center mx-auto mb-4">
      <svg class="w-8 h-8 text-[#059669]" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <p class="text-[20px] font-bold text-[#111827] mb-2">Approve Request?</p>
    <p class="text-[14px] text-[#6B7280] mb-7">This will grant the user access to the portal. This action cannot be undone.</p>
    <div class="flex gap-3">
      <button type="button" (click)="show_approve_modal = false" class="flex-1 py-3 rounded-full border border-[#D1D5DB] text-[#374151] text-[15px] font-semibold hover:bg-gray-50 transition">
        Cancel
      </button>
      <button type="button" (click)="approve()" [disabled]="action_loading" class="flex-1 py-3 rounded-full bg-[#059669] text-white text-[15px] font-semibold hover:opacity-90 transition disabled:opacity-60">
        {{ action_loading ? 'Approving...' : 'Yes, Approve' }}
      </button>
    </div>
  </div>
</div>

<!-- ═══════════════════════════════════════════════════
     REJECT CONFIRMATION MODAL
     ═══════════════════════════════════════════════════ -->
<div *ngIf="show_reject_modal" class="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
  <div class="bg-white rounded-2xl shadow-2xl px-8 py-8 w-full max-w-sm mx-4 text-center">
    <div class="w-16 h-16 rounded-full bg-[#FEE2E2] flex items-center justify-center mx-auto mb-4">
      <svg class="w-8 h-8 text-[#EF4444]" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </div>
    <p class="text-[20px] font-bold text-[#111827] mb-2">Reject Request?</p>
    <p class="text-[14px] text-[#6B7280] mb-7">This will block the user's access to the portal. The user will be notified of the rejection.</p>
    <div class="flex gap-3">
      <button type="button" (click)="show_reject_modal = false" class="flex-1 py-3 rounded-full border border-[#D1D5DB] text-[#374151] text-[15px] font-semibold hover:bg-gray-50 transition">
        Cancel
      </button>
      <button type="button" (click)="reject()" [disabled]="action_loading" class="flex-1 py-3 rounded-full bg-[#EF4444] text-white text-[15px] font-semibold hover:opacity-90 transition disabled:opacity-60">
        {{ action_loading ? 'Rejecting...' : 'Yes, Reject' }}
      </button>
    </div>
  </div>
</div>